<template>
  <card-component title="Jinetes" :subtitle="subtitle" class="has-table has-mobile-sort-spaced" :header-search-input="false">
    <div slot="headerRight" class="card-header-icon">
      <div class="columns">
        <div class="column">
          <rider-table-filter @filtered="applyFilter"/>
        </div>
      </div>
    </div>
    <div slot="content">
      <b-table
        :loading="isLoading"
        :paginated="paginated"
        :per-page="perPage"
        :striped="isStriped"
        :hoverable="hoverable"
        :data="riders"
      >
        <template slot-scope="props">
          <b-table-column label="Nombre" field="name" >
            <b-icon :icon="genderIcon(props.row.person.gender)" :type="genderedColors(props.row.person.gender)" size="is-small" v-if="props.row.person  && props.row.person.gender">
            </b-icon>
            <b-icon icon="help" size="is-small" v-else>
            </b-icon>
            <b> {{props.row.lastname}} {{props.row.name}}</b>
          </b-table-column>
          <b-table-column label="Email" field="email">
            <p>{{props.row.email}}</p>
          </b-table-column>
          <!-- <b-table-column label="Ciudad" field="phone" centered>
            {{ props.row.person && props.row.person.location ? props.row.person.location : 'S/I'}}
          </b-table-column> -->
          <b-table-column label="Teléfono" field="phone" centered>
            {{ props.row.person && props.row.person.phone ? props.row.person.phone : 'S/I'}}
          </b-table-column>
          <b-table-column label="Edad" field="age" centered>
            {{ props.row.person ? calculeAge(props.row.person.birth_date)  : 'S/I'}}
          </b-table-column>
          <b-table-column label="N° Caballos" field="horses" centered>
            <b-tag type="is-ligth">{{props.row.horses.length}}</b-tag>
          </b-table-column>
          <b-table-column label="Estado" field="horses" centered>
            <b-tag type="is-info" v-if="props.row.user_status_id === 1">Activo</b-tag>
            <b-tag type="is-dark" v-else>Inactivo</b-tag>
          </b-table-column>
          <!-- <b-table-column label="Nota" field="gender" sortable></b-table-column>
          <b-table-column label="Ranking" field="gender" sortable></b-table-column> -->
          <b-table-column custom-key="actions" class="is-actions-cell">
            <div class="buttons is-right">
              <b-button type="is-success" size="is-small" @click="$emit('edit', props.row.id)">
                Editar
              </b-button>
              <router-link :to="{name:'riders.detail', params: {id: props.row.id}}" :class="['button is-small', 'is-primary']">
                Ver detalles
              </router-link>
            </div>
          </b-table-column>
        </template>
        <section class="section" slot="empty">
          <div class="content has-text-grey has-text-centered">
            <template v-if="isLoading">
              <p>
                <b-icon icon="dots-horizontal" size="is-large" />
              </p>
              <p>Cargando Caballos...</p>
            </template>
            <template v-else>
              <p>
                <b-icon icon="horseshoe" size="is-large" />
              </p>
              <p>No hay registros de Caballos&hellip;</p>
            </template>
          </div>
        </section>
      </b-table>
    </div>
  </card-component>
</template>

<script>

import CardComponent from '@/components/CardComponent'
import RiderTableFilter from './filters/RiderTableFilter'
import RiderService from '@/services/RiderService'

export default {
  props: {
    reload: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CardComponent,
    RiderTableFilter
  },
  created () {
  },
  data () {
    return {
      riders: [],
      paginated: true,
      perPage: 10,
      isStriped: true,
      isNarrowed: false,
      hoverable: true,
      isFocusable: false,
      isLoading: false,
      hasMobileCards: true,
      filters: null
    }
  },
  methods: {
    applyFilter (data) {
      this.filters = data
      this.getRiders()
    },
    async getRiders () {
      let params = {
        'include[0]': 'horses',
        'include[1]': 'person',
        ...this.filters
      }
      this.isLoading = true
      let response = await RiderService.getRiders(params)
      this.riders = response.data.data
      this.$emit('update:reload', false)
      this.isLoading = false
    },
    calculeAge (date) {
      let years = this.moment().diff(date, 'years')
      return years
    },
    genderIcon (gender) {
      let icon = ''
      if (gender === 'M') {
        icon = 'gender-male'
      } else if (gender === 'F') {
        icon = 'gender-female'
      }
      return icon
    },
    genderedColors (gender) {
      return gender === 'M' ? 'is-info' : 'is-danger'
    },
    genderToText (gender) {
      let genderText = 'S/I'
      if (gender === 'M') {
        genderText = 'Masculino'
      } else if (gender === 'F') {
        genderText = 'Femenino'
      }
      return genderText
    }
  },
  computed: {
    subtitle () {
      let dataLenght = this.riders.length
      let plural = dataLenght === 1 ? '' : 's'
      return `${dataLenght} jinete${plural} registrado${plural}`
    }
  },
  watch: {
    reload (value) {
      if (value === true) {
        this.getRiders()
      }
    }
  }
}
</script>
